import { render, staticRenderFns } from "./TermOfServiceModal.vue?vue&type=template&id=393f7255&"
import script from "./TermOfServiceModal.vue?vue&type=script&lang=js&"
export * from "./TermOfServiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports